import { generatePath, useHistory } from 'react-router-dom'
import ROUTES from 'app/routes'
import {
  useNetworkHomeJobsRouteParams,
  useCurrentHomeSiteId,
  useNetworkWLANsCounts,
} from 'features/networkAi/hooks'
import { useIntl } from 'react-intl'
import { makePublicUrl } from 'app/utils/publicUrl'
import { networkStatusWLANsMessages } from './messages'
import {
  NetworkStatusWLANsContainer,
  NetworkStatusWLANsHeader,
  NetworkStatusWLANsHeaderTitle,
  NetworkStatusWLANsBody,
  NetworkStatusWLANsItem,
  NetworkStatusWLANsIcon,
  NetworkStatusWLANsCount,
  NetworkStatusWLANsCountLabel,
  NetworkStatusWLANsForwardButton,
  NetworkStatusWLANsForwardIcon,
} from './styles'

function NetworkStatusWLANs() {
  const history = useHistory()
  const { rootDomainId, homeId, jobId } = useNetworkHomeJobsRouteParams()
  const siteId = useCurrentHomeSiteId({ homeId })
  const { formatMessage } = useIntl()
  const { wlansTotal, wlansEnabled, wlansGuest } = useNetworkWLANsCounts({
    siteId,
  })

  const handleNavigateWLANsClick = () => {
    const pathname = generatePath(ROUTES.networkAi.dashboard.networkWLANs, {
      rootDomainId,
      jobId,
      homeId,
    })
    history.push(pathname)
  }

  return (
    <NetworkStatusWLANsContainer>
      <NetworkStatusWLANsHeader>
        <NetworkStatusWLANsHeaderTitle>WLANs</NetworkStatusWLANsHeaderTitle>
        <NetworkStatusWLANsForwardButton onClick={handleNavigateWLANsClick}>
          <NetworkStatusWLANsForwardIcon
            src={makePublicUrl(`images/networkIcons/arrow-forward.svg`)}
          />
        </NetworkStatusWLANsForwardButton>
      </NetworkStatusWLANsHeader>

      <NetworkStatusWLANsBody>
        <NetworkStatusWLANsItem>
          <NetworkStatusWLANsCount>{wlansTotal}</NetworkStatusWLANsCount>
          <NetworkStatusWLANsCountLabel>
            {formatMessage(networkStatusWLANsMessages.wlansTotalText)}
          </NetworkStatusWLANsCountLabel>
        </NetworkStatusWLANsItem>

        <NetworkStatusWLANsItem>
          <NetworkStatusWLANsCount>{wlansEnabled}</NetworkStatusWLANsCount>
          <NetworkStatusWLANsCountLabel>
            {formatMessage(networkStatusWLANsMessages.wlansEnabledText)}
          </NetworkStatusWLANsCountLabel>
        </NetworkStatusWLANsItem>

        <NetworkStatusWLANsItem>
          <NetworkStatusWLANsCount>{wlansGuest}</NetworkStatusWLANsCount>
          <NetworkStatusWLANsCountLabel>
            {formatMessage(networkStatusWLANsMessages.wlansGuestText)}
          </NetworkStatusWLANsCountLabel>
        </NetworkStatusWLANsItem>

        <NetworkStatusWLANsItem>
          <NetworkStatusWLANsIcon
            src={makePublicUrl(`images/networkIcons/wlans.svg`)}
          />
        </NetworkStatusWLANsItem>
      </NetworkStatusWLANsBody>
    </NetworkStatusWLANsContainer>
  )
}

export default NetworkStatusWLANs
